import {fileApi} from '@/api/dify';

export default {
    data() {
        return {
            uploadedFiles: [],
            maxFileCount: 6,
        };
    },
    computed: {
        fileCountStatus() {
            return `${this.uploadedFiles.length}/${this.maxFileCount}个文件`;
        },
        isFileCountLimit() {
            return this.uploadedFiles.length >= this.maxFileCount;
        },
    },
    watch: {
        uploadedFiles: {
            handler(newFiles) {
                this.$nextTick(() => {
                    this.$emit('files-changed', newFiles);
                    this.$emit('file-status-changed', {
                        count: newFiles.length,
                        maxCount: this.maxFileCount,
                        status: this.fileCountStatus,
                        isLimit: this.isFileCountLimit,
                    });
                });
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        async handleFileChange(file) {
            if (!file) return;

            // 检查文件数量限制
            if (this.uploadedFiles.length >= this.maxFileCount) {
                this.$message.warning(`最多只能上传${this.maxFileCount}个文件，请先删除现有文件后再试`);
                return;
            }

            // 立即添加文件到列表，显示上传中状态
            const uid = Date.now();
            const uploadingFile = {
                uid,
                id: uid,
                name: file.name,
                type: file.type || this.getMimeTypeFromName(file.name),
                size: file.size,
                url: '',
                status: 'uploading',
                percent: 0,
                raw: file,
            };

            this.uploadedFiles.push(uploadingFile);

            // 进度更新函数
            const updateProgress = (percent) => {
                const index = this.uploadedFiles.findIndex(f => f.uid === uid);
                if (index !== -1 && this.uploadedFiles[index]) {
                    const safePercent = Math.min(percent, 99);
                    this.$set(this.uploadedFiles[index], 'percent', safePercent);
                    this.$set(this.uploadedFiles[index], 'status', 'uploading');
                }
            };

            try {
                const response = await fileApi.uploadFile(file, 'default-user', updateProgress);

                // 上传成功，更新文件信息
                const index = this.uploadedFiles.findIndex(f => f.uid === uid);
                if (index !== -1 && this.uploadedFiles[index]) {
                    const result = response.result || {};
                    this.$set(this.uploadedFiles, index, {
                        id: result.id || uid,
                        name: result.name || file.name,
                        url: result.url || '',
                        type: result.type || file.type,
                        size: result.size || file.size,
                        uid: result.id || uid,
                        fileSize: result.size || file.size,
                        imgFile: file,
                        showDelIcon: true,
                        status: 'done',
                        percent: 100,
                    });
                }
            } catch (error) {
                // 上传失败，直接从列表中移除（不显示错误状态）
                const index = this.uploadedFiles.findIndex(f => f.uid === uid);
                if (index !== -1) {
                    this.uploadedFiles.splice(index, 1);
                }
                this.$message.error('文件上传失败：' + error.message);
            }
        },

        getMimeTypeFromName(fileName) {
            const ext = fileName.split('.').pop().toLowerCase();
            const mimeMap = {
                pdf: 'application/pdf',
                doc: 'application/msword',
                docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                xls: 'application/vnd.ms-excel',
                xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                ppt: 'application/vnd.ms-powerpoint',
                pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                txt: 'text/plain',
                csv: 'text/csv',
                json: 'application/json',
                html: 'text/html',
                css: 'text/css',
                js: 'application/javascript',
                jpg: 'image/jpeg',
                jpeg: 'image/jpeg',
                png: 'image/png',
                gif: 'image/gif',
                bmp: 'image/bmp',
                svg: 'image/svg+xml',
                webp: 'image/webp',
                mp3: 'audio/mpeg',
                wav: 'audio/wav',
                mp4: 'video/mp4',
                avi: 'video/avi',
                zip: 'application/zip',
                rar: 'application/x-rar-compressed',
            };
            return mimeMap[ext] || 'application/octet-stream';
        },

        handleDeleteUploadedFile(item) {
            this.uploadedFiles = this.uploadedFiles.filter(file => file.id !== item.id);
            this.$emit('delete-file', item);
        },
    },
};
